/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CombinedGoodsListForPackCombinedGoodsForPackVo } from './CombinedGoodsListForPackCombinedGoodsForPackVo';
import {
    CombinedGoodsListForPackCombinedGoodsForPackVoFromJSON,
    CombinedGoodsListForPackCombinedGoodsForPackVoFromJSONTyped,
    CombinedGoodsListForPackCombinedGoodsForPackVoToJSON,
    CombinedGoodsListForPackCombinedGoodsForPackVoToJSONTyped,
} from './CombinedGoodsListForPackCombinedGoodsForPackVo';

/**
 * 
 * @export
 * @interface CombinedGoodsListForPackVo
 */
export interface CombinedGoodsListForPackVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof CombinedGoodsListForPackVo
     */
    orderCode?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof CombinedGoodsListForPackVo
     */
    userId?: number;
    /**
     * 用户名
     * @type {string}
     * @memberof CombinedGoodsListForPackVo
     */
    userName?: string;
    /**
     * 用户编码
     * @type {string}
     * @memberof CombinedGoodsListForPackVo
     */
    userCode?: string;
    /**
     * 请求类型
     * @type {number}
     * @memberof CombinedGoodsListForPackVo
     */
    requestType?: number;
    /**
     * 仓库ID
     * @type {number}
     * @memberof CombinedGoodsListForPackVo
     */
    warehouseId?: number;
    /**
     * 纸箱唛头号前缀
     * @type {string}
     * @memberof CombinedGoodsListForPackVo
     */
    boxMarknoPrefix?: string;
    /**
     * 托盘唛头号前缀
     * @type {string}
     * @memberof CombinedGoodsListForPackVo
     */
    palletMarknoPrefix?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof CombinedGoodsListForPackVo
     */
    internationalTransportMethodId?: number;
    /**
     * 运输方式韩文名
     * @type {string}
     * @memberof CombinedGoodsListForPackVo
     */
    transportMethodNameKr?: string;
    /**
     * 收货人韩文名
     * @type {string}
     * @memberof CombinedGoodsListForPackVo
     */
    receiverNameKr?: string;
    /**
     * 包装状态
     * @type {number}
     * @memberof CombinedGoodsListForPackVo
     */
    packageStatus?: number;
    /**
     * 订单当前所在国家ID
     * @type {number}
     * @memberof CombinedGoodsListForPackVo
     */
    orderCurrentNationId?: number;
    /**
     * 有误管理 处理商品之前的订单镜像id
     * @type {number}
     * @memberof CombinedGoodsListForPackVo
     */
    beforeErrorProcessOrderId?: number;
    /**
     * 合包商品列表
     * @type {Array<CombinedGoodsListForPackCombinedGoodsForPackVo>}
     * @memberof CombinedGoodsListForPackVo
     */
    combinedGoodsForPackVOList?: Array<CombinedGoodsListForPackCombinedGoodsForPackVo>;
}

/**
 * Check if a given object implements the CombinedGoodsListForPackVo interface.
 */
export function instanceOfCombinedGoodsListForPackVo(value: object): value is CombinedGoodsListForPackVo {
    return true;
}

export function CombinedGoodsListForPackVoFromJSON(json: any): CombinedGoodsListForPackVo {
    return CombinedGoodsListForPackVoFromJSONTyped(json, false);
}

export function CombinedGoodsListForPackVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombinedGoodsListForPackVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'boxMarknoPrefix': json['boxMarknoPrefix'] == null ? undefined : json['boxMarknoPrefix'],
        'palletMarknoPrefix': json['palletMarknoPrefix'] == null ? undefined : json['palletMarknoPrefix'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'transportMethodNameKr': json['transportMethodNameKr'] == null ? undefined : json['transportMethodNameKr'],
        'receiverNameKr': json['receiverNameKr'] == null ? undefined : json['receiverNameKr'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'orderCurrentNationId': json['orderCurrentNationId'] == null ? undefined : json['orderCurrentNationId'],
        'beforeErrorProcessOrderId': json['beforeErrorProcessOrderId'] == null ? undefined : json['beforeErrorProcessOrderId'],
        'combinedGoodsForPackVOList': json['combinedGoodsForPackVOList'] == null ? undefined : ((json['combinedGoodsForPackVOList'] as Array<any>).map(CombinedGoodsListForPackCombinedGoodsForPackVoFromJSON)),
    };
}

export function CombinedGoodsListForPackVoToJSON(json: any): CombinedGoodsListForPackVo {
    return CombinedGoodsListForPackVoToJSONTyped(json, false);
}

export function CombinedGoodsListForPackVoToJSONTyped(value?: CombinedGoodsListForPackVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'requestType': value['requestType'],
        'warehouseId': value['warehouseId'],
        'boxMarknoPrefix': value['boxMarknoPrefix'],
        'palletMarknoPrefix': value['palletMarknoPrefix'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'transportMethodNameKr': value['transportMethodNameKr'],
        'receiverNameKr': value['receiverNameKr'],
        'packageStatus': value['packageStatus'],
        'orderCurrentNationId': value['orderCurrentNationId'],
        'beforeErrorProcessOrderId': value['beforeErrorProcessOrderId'],
        'combinedGoodsForPackVOList': value['combinedGoodsForPackVOList'] == null ? undefined : ((value['combinedGoodsForPackVOList'] as Array<any>).map(CombinedGoodsListForPackCombinedGoodsForPackVoToJSON)),
    };
}

